/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import ShowProgress from '../ui/Backdrop';
import Theme from '../ui/Theme';
import { getCapstoneID, showProgress, getCapstoneDetails } from '../../redux/actions/DealershipActions';
import 'react-toastify/dist/ReactToastify.css';
import service from '../../apis/service';
import { MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles((theme) => ({
  resize: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '27em',
    padding: '5px 10px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    marginTop: '9px',
  },
  resize2: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '38em',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    maxHeight: '58vh',

    overflow: 'scroll',
  },
  cancelBtn: {
    width: '200px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  createBtn: {
    width: '200px',
    height: '42px',
    marginLeft: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
}));

const AddNewCapstone = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const levelDetails = useSelector((state) => state.getLevelDetails);
  const selectedLevelID = useSelector((state) => state.getSelectedLevelID);
  const capstoneID = useSelector((state) => state.getCapstoneID);
  const capstoneDetails = useSelector((state) => state.getCapstoneDetails.capstonedetails);

  const [viewCapstonePop, setViewCapstonePop] = useState(props.open);
  const [capstoneTitle, setCapstoneTitle] = useState('');
  const [capstoneDescription, setCapstoneDescription] = useState('');

  useEffect(() => {
    if (props.edit === true) {
      setCapstoneTitle(capstoneDetails?.title);
      setCapstoneDescription(capstoneDetails?.description);
    }
  }, []);

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!capstoneTitle) {
      formIsValid = false;
      errors.push('Please enter capstone title.');
    }
    if (!capstoneDescription) {
      formIsValid = false;
      errors.push('Please enter capstone descriptions.');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };
  const submit = async (edit) => {
    const check = validateForm();
    let data = '';
    if (check === true && edit === false) {
      dispatch(showProgress(true));

      data = JSON.stringify({
        levelId: selectedLevelID,
        title: capstoneTitle,
        description: capstoneDescription,
      });

      await service
        .post(apiEndpoints.JOURNEY_CAPSTONE, data)
        .then((response) => {
          dispatch(showProgress(false));
          dispatch(getCapstoneDetails('fetch', response));
          dispatch(getCapstoneID(response.id));
          notifySuccess('Completed Successfully');
          closePopup();
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
          closePopup();
        });
    } else if (check === true && edit === true) {
      dispatch(showProgress(true));
      data = JSON.stringify({
        title: capstoneTitle,
        description: capstoneDescription,
      });
      await service
        .put(apiEndpoints.JOURNEY_CAPSTONE_BY_ID.replace('CAP_ID', capstoneID), data)
        .then((response) => {
          dispatch(getCapstoneDetails('fetch', response));
          dispatch(showProgress(false));
          notifySuccess('Completed Successfully');
          closePopup();
        })
        .catch((error) => {
          console.log(error);
          dispatch(showProgress(false));
          closePopup();
        });
    }
  };
  const handleCapstoneTitleChange = (e) => {
    setCapstoneTitle(e.target.value);
  };
  const handleCapstoneDescriptionChange = (e) => {
    setCapstoneDescription(e.target.value);
  };
  const closePopup = () => {
    setViewCapstonePop(false);
    props.close();
  };

  return (
    <Modal
      isOpen={viewCapstonePop}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '392px',
          width: '492px',

          overflow: 'auto',
        },
      }}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item>
          <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              {props.edit === false ? 'Add capstone' : 'Update capstone'}
            </Grid>
            <Grid item className={classes.popupSubHeading}>
              In the Level: {levelDetails.leveldetails.title}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
        <Grid item>
          <TextField
            id="capstoneTitleId"
            name="capstoneTitle"
            required
            autoFocus
            autoComplete="off"
            autoSave="off"
            onChange={handleCapstoneTitleChange}
            placeholder="Enter Capstone's title here"
            multiline
            InputProps={{
              disableUnderline: true,
              classes: {
                input: classes.resize,
              },
            }}
            value={capstoneTitle}
            rows={5}
          />
        </Grid>
        <Grid item>
          <div className={classes.popupLabels}>
            <label htmlFor="capstoneDescription">Description of this capstone</label>
          </div>

          <TextField
            id="capstoneDescriptionId"
            name="capstoneDescription"
            required
            autoComplete="off"
            autoSave="off"
            onChange={handleCapstoneDescriptionChange}
            placeholder="Enter capstone description here"
            multiline
            value={capstoneDescription}
            InputProps={{
              disableUnderline: true,
              classes: {
                input: classes.resize2,
              },
            }}
            rows={5}
          />
        </Grid>
        <Grid item>
          <Grid container direction="row" style={{ marginLeft: '8%' }}>
            <Grid item>
              <Button onClick={closePopup} variant="contained" disableElevation className={classes.cancelBtn}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.createBtn}
                onClick={() => submit(props.edit)}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ShowProgress />
    </Modal>
  );
};

export default AddNewCapstone;
